import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import mailReducer from './slices/mail';
import chatReducer from './slices/chat';
import blogReducer from './slices/blog';
import userReducer from './slices/user';
import productReducer from './slices/product';
import calendarReducer from './slices/calendar';
import kanbanReducer from './slices/kanban';
import adminReducer from './slices/ai-slices/admin';
import eventsReducer from './slices/ai-slices/events';
import customDashboard from './slices/customDashboardSlices/dashboardSlice'

import { authReduceR } from './reducer/authReducer';
import { scoreReduceR } from "./reducer/scoreReducer";
import { empSummaryReduceR, empActivityReduceR } from './reducer/empReducer';
import { AllStaffReduceR, listTeamReduceR, EmpReduceR, SupReduceR, GroupReduceR, TeamReduceR, TaskReduceR, GoalReduceR, restoreReduceR, listGrpReduceR, listSupReduceR } from './reducer/staffReducer';
import filterDataReducer from './slices/AnalyticsSlices/SupervisorFilterSlice'
import StaffFilterDataReducer from './slices/AnalyticsSlices/StaffFilterSlice'
import EvaluationFilterDataReducer from './slices/AnalyticsSlices/EvaluationFilterSlice'
import ScorecardFilterDataReducer from './slices/AnalyticsSlices/ScorecardFilterSlice'
import TeamFilterDataReducer from './slices/AnalyticsSlices/TeamFilterSlice'
import GroupFilterDataReducer from './slices/AnalyticsSlices/GroupFilterSlice'
import AnalyticDashboardSlice from './slices/AnalyticsSlices/AnalyticCustomDashboardSlices/AnalyticDashboardSlice'
import ReportsFilterSlice from "./slices/ReportsModule/ReportsFilterSlice"
import SnapshotFilterSlice from "./slices/ReportsModule/SnapshotFilterSlice"
// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['filterFields', 'staffFilterFields',
    'evalFilterFields', 'ScorecardFilterSlice', 'teamFilterFields', 'groupFilterFields',
    'analyticsDashboard', 'reportsFilterFields', "snapshotFilterFields"] // to persist filter fields selection
};

const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout']
};

const rootReducer = combineReducers({
  mail: mailReducer,
  chat: chatReducer,
  blog: blogReducer,
  user: userReducer,
  calendar: calendarReducer,
  kanban: kanbanReducer,
  product: persistReducer(productPersistConfig, productReducer),
  info: authReduceR,
  staff: AllStaffReduceR,
  groups: GroupReduceR,
  teams: TeamReduceR,
  tasks: TaskReduceR,
  goals: GoalReduceR,
  restoreItem: restoreReduceR,
  emps: EmpReduceR,
  sups: SupReduceR,
  scoreList: scoreReduceR,
  empSummary: empSummaryReduceR,
  empActivity: empActivityReduceR,
  stateSupList: listSupReduceR,
  stateGrpList: listGrpReduceR,
  stateTeamList: listTeamReduceR,
  admin: adminReducer,
  events: eventsReducer,
  customDashboard, // not in use for now, will use in future
  filterFields: filterDataReducer,
  staffFilterFields: StaffFilterDataReducer,
  evalFilterFields: EvaluationFilterDataReducer,
  ScorecardFilterSlice: ScorecardFilterDataReducer,
  teamFilterFields: TeamFilterDataReducer,
  groupFilterFields: GroupFilterDataReducer,
  analyticsDashboard: AnalyticDashboardSlice,
  reportsFilterFields: ReportsFilterSlice,
  snapshotFilterFields: SnapshotFilterSlice
});

export { rootPersistConfig, rootReducer };
